<template>
  <div>
    <h3 class="text-left text-font-24">ข้อมูลส่วนบุคคล</h3>
    <div class="pd-b-3">
      <el-upload
        action="#"
        class="box-image-upload box-profile text-center"
        :class="{ haveImage: image != null }"
        ref="upload"
        list-type="picture-card"
        :auto-upload="false"
        :on-change="uploadImage"
      >
        <div slot="default">
          <span class="icon">
            <i class="fas fa-1x fa-camera"></i>
            <p>อัพโหลดรูปภาพ</p>
          </span>

          <div class="preview">
            <avatar
              v-if="showProfile"
              :rounded="false"
              :username="''"
              :src="getUrlImage(image)"
              :size="150"
            >
            </avatar>
          </div>
        </div>
      </el-upload>
    </div>
    <ProfilePersonalInfoForm :value="value" @setFormStep="nextStep" />
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import ProfilePersonalInfoForm from "@/components/profile/ProfilePersonalInfoForm";

export default {
  props: {
    value: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  components: {
    Avatar,
    ProfilePersonalInfoForm,
  },
  data() {
    return {
      dataInput: null,
      image: null,
      showProfile: true,
    };
  },
  watch: {
    value() {
      this.setImage();
    },
  },
  mounted() {
    this.setImage();
  },
  methods: {
    setImage() {
      if (this.value != null) {
        this.image = this.value.image;
      }
    },
    uploadImage(file) {
      this.showProfile = false;
      this.image = file;
      setTimeout(() => {
        this.showProfile = true;
      }, 100);
    },
    getUrlImage(image) {
      if (image != null) {
        return URL.createObjectURL(image.raw);
      } else {
        return "";
      }
    },
    nextStep(input) {
      let obj = input;
      input["image"] = this.image;
      this.$emit("setFormStep", input, 1);
    },
  },
};
</script>
